export const STATIC_CONTENT_URL = 'https://img-cdn.misfitsmarket.com/';
export const NANO_BANNER_SCROLL_Y = 40;
export const BOYSENBERRY_S3_IMAGES = `${STATIC_CONTENT_URL}boysenberry/images/`;
export const BOYSENBERRY_S3_ICONS = `${STATIC_CONTENT_URL}boysenberry/icons/`;
